import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import { FuseSharedModule } from '@fuse/shared.module';


import { errorRoutes } from './error.route';
import { ErrorComponent } from './error.component';
import { AccessDeniedPageComponent } from './access-denied-page';
import { NotFoundPageComponent } from './not-found-page';
import { InternalSeverErrorPageComponent } from './internal-sever-error-page';
import { MaintenancePageComponent } from './maintenance-page';

const COMPONENTS = [
  ErrorComponent,
  AccessDeniedPageComponent,
  NotFoundPageComponent,
  InternalSeverErrorPageComponent,
  MaintenancePageComponent
];

@NgModule({
  declarations: [...COMPONENTS],
  imports: [RouterModule.forChild(errorRoutes), MatIconModule, FuseSharedModule, TranslateModule],
})
export class ErrorPagesModule {}
